import { makeStyles } from "@material-ui/core";
import { colors } from "../../shared/utils";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 12,
    width: "100%",
    minWidth: 0,
  },
  title: {
    color: colors.blueDarken,
    fontWeight: "bold",
  },
  tablaWrapper: {
    width: "100%",
    minWidth: 0,
    overflowX: "auto",
    borderRadius: 8,
  },
  grid: {
    minWidth: "815px",
    border: "none",
    "& .MuiDataGrid-iconButtonContainer": {
      display: "none",
    },
    "& .header": {
      background: colors.blueLighten,
      color: colors.white,
    },
    "&.MuiDataGrid-root .MuiDataGrid-cell:focus": {
      outline: "none",
    },
    "& .MuiDataGrid-columnsContainer": {
      background: colors.blueLighten,
    },
  },
  vacio: {
    color: colors.greyFont,
    textAlign: "center",
    padding: "16px 0",
  },
});

export default useStyles;
